module.exports = __webpack_public_path__ + "static/leadership-3d557ccf3e546e2833040f020eb11ae0.jpg";